<script>
import api from '@utils/api'
import { isEmpty } from 'lodash'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'GoodsDrumoil',
  props: {
    drumoil: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        drum: null,
        oil: null,
        volume: null,
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      rules: {
        drum: [x => !!x || this.$t('validation__is_required')],
        oil: [x => !!x || this.$t('validation__is_required')],
      },
      isNew: true,
      volumeLoading: false,
    }
  },
  computed: {
    oil() {
      return this.$store.getters['data/getOil']
    },
    drum() {
      return this.$store.getters['data/getDrum']
    },
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  mounted() {
    this.item = {
      ...this.drumoil,
      volume: this.modifyData(this.drumoil.volume),
    }
    this.isNew = isEmpty(this.drumoil)
  },
  methods: {
    createDrumoil() {
      if (!this.$refs.drumoilForm.validate()) return
      this.loading = true
      const data = {
        ...this.item,
      }
      const volume = parseFloat(this.item.volume.toString().replace(',', '.'))
      if (!volume || volume === 0) data.volume = null
      else data.volume = volume * this.unitsMeasurement.volumeMultiplier
      api
        .createGoodsDrumoil({
          goodsId: this.$route.params.goodsId,
          data,
        })
        .then(response => {
          Object.assign(this.item, {
            ...response,
            volume: this.modifyData(response.volume),
          })
          this.isNew = false
          this.$store.dispatch('data/updateDictionary', 'goods')
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    getValueInMeasureUnits(volume) {
      if (volume) return this.unitsMeasurement.volumeMeasure
      else return this.unitsMeasurement.lengthMeasure
    },
    modifyData(value) {
      if (!value) return null
      return parseFloat(value) / this.unitsMeasurement.volumeMultiplier
    },
    updateDrum(value) {
      this.item.drum = value
      this.setDefaultVolume(value)
    },
    setDefaultVolume(value) {
      this.volumeLoading = true
      api
        .getGoodsCharacteristic({
          goodsId: value,
          params: { size: 10, page: 1 },
        })
        .then(response => {
          const volume = response.content.find(
            elem => elem.characteristic === 114
          )
          if (!volume.value) return
          this.item.volume = this.modifyData(volume.value)
        })
        .catch(() => {})
        .then(() => {
          this.volumeLoading = false
        })
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex lg4>
        <v-form 
          ref="drumoilForm" 
          v-model="valid" 
          lazy-validation>
          <v-select
            :items="oil"
            :label="$t('label__oil')"
            :readonly="!userAllowedToUpdate"
            v-model="item.oil"
            :rules="rules.oil"
            item-text="shortName"
            item-value="id"
            required
            autocomplete
          />
          <v-select
            :items="drum"
            :label="$t('label__drum')"
            :readonly="!userAllowedToUpdate"
            :value="item.drum"
            :rules="rules.drum"
            item-text="shortName"
            item-value="id"
            required
            autocomplete
            @change="updateDrum($event)"
          />
          <v-text-field
            :label="
              `${$t('label__volume')} (${$t(
                `label__${getValueInMeasureUnits(true)}`
              )})`
            "
            :readonly="!userAllowedToUpdate"
            v-model="item.volume"
            :loading="volumeLoading"
            name="volume"
            autocomplete="off"
          />
        </v-form>
        <small>* {{ $t('label__requier_small_text') }}</small>
        <div :class="$style.btnWrapper">
          <v-btn
            v-if="userAllowedToUpdate"
            :loading="loading"
            :disabled="loading"
            :color="isNew ? 'primary' : 'success'"
            @click="createDrumoil"
          >
            {{ isNew ? $t('buttons__create') : $t('buttons__update') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin: 10px -7px;
}
</style>
